import React from 'react'
import { ReloadOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'

type Props = { loading: boolean; onRefresh: () => void }

/** Refetches every section. */
export const RefreshButton: React.FC<Props> = ({ loading, onRefresh }) => (
    <Tooltip title="Refresh">
        <Button
            aria-label="Refresh dashboard"
            style={{ width: 32, height: 32, padding: 0 }}
            icon={<ReloadOutlined spin={loading} />}
            onClick={onRefresh}
        />
    </Tooltip>
)
